/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/poll',
  name: 'Poll',
  component: () => import('@/views/poll/Index'),
},
// {
//   path: '/tadris-history',
//   name: 'tadrisHistory',
//   component: () => import('@/views/tadris/Index'),
// }
]

